<template>
	<div
		v-if="shouldShow"
		:class="wrapperClasses"
		role="region"
		:aria-label="$t('cookieConsent.banner.ariaLabel')"
	>
		<div
			class="flex flex-col items-center w-full max-w-5xl px-4 py-6 md:px-6"
		>
			<div
				class="flex flex-col md:items-center gap-4 md:flex-row md:gap-[24px]"
			>
				<div class="flex flex-col">
					<p class="mb-1 text-sm font-semibold text-gray-800">
						{{ $t('cookieConsent.banner.title') }}
					</p>
					<p
						class="mb-1 text-sm text-gray-600"
						v-html="paragraph1WithLink"
					></p>
				</div>

				<div
					class="flex flex-wrap items-center justify-end gap-3 shrink-0"
				>
					<Button
						type="tertiary"
						size="sm"
						@click="handlePersonalize"
					>
						{{ $t('cookieConsent.banner.personalize') }}
					</Button>
					<Button type="secondary" size="sm" @click="handleRejectAll">
						{{ $t('cookieConsent.banner.rejectAll') }}
					</Button>
					<Button type="primary" size="sm" @click="handleAcceptAll">
						{{ $t('cookieConsent.banner.acceptAll') }}
					</Button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Button from '~/components/ui/common/Button'

export default {
	name: 'CookieBanner',
	components: {
		Button
	},
	props: {
		position: {
			type: String,
			default: 'bottom',
			validator: value => ['bottom', 'top'].includes(value)
		}
	},
	computed: {
		shouldShow() {
			return !this.$cookieConsent.hasAnswered()
		},
		paragraph1WithLink() {
			const rawText = this.$t('cookieConsent.banner.paragraph1')
			const privacyUrl = this.sanitizeUrl(
				this.$t('cookieConsent.privacy.url')
			)
			const privacyLabel = this.escapeHtml(
				this.$t('cookieConsent.privacy.label')
			)
			const linkClass = 'underline text-gray-600'
			const link = `<a href="${privacyUrl}" class="${linkClass}" rel="noopener noreferrer">${privacyLabel}</a>`

			// Escape the paragraph text, then replace the placeholder with the safe link
			// Handle case where translation has dot after placeholder
			if (rawText.includes('{privacyLink}.')) {
				const escaped = this.escapeHtml(
					rawText.replace('{privacyLink}.', '\x00LINK_DOT\x00')
				)
				return escaped.replace(
					'\x00LINK_DOT\x00',
					link.replace('</a>', '.</a>')
				)
			}

			const escaped = this.escapeHtml(
				rawText.replace('{privacyLink}', '\x00LINK\x00')
			)
			return escaped.replace('\x00LINK\x00', link)
		},
		wrapperClasses() {
			const base =
				'fixed inset-x-0 z-50 flex flex-col items-center bg-white border-gray-200'
			const position =
				this.position === 'top'
					? 'top-0 border-b shadow-md'
					: 'bottom-0 border-t shadow-[0_-4px_12px_rgba(0,0,0,0.1)]'
			return `${base} ${position}`
		}
	},
	methods: {
		async handleAcceptAll() {
			await this.$store.dispatch('cookieConsent/acceptAll')
		},
		async handleRejectAll() {
			await this.$store.dispatch('cookieConsent/rejectAll')
		},
		handlePersonalize() {
			this.$emit('open-settings')
		},
		escapeHtml(str) {
			const div = document.createElement('div')
			div.textContent = str
			return div.innerHTML
		},
		sanitizeUrl(url) {
			// Only allow http, https, or relative paths
			if (/^(https?:\/\/|\/)/i.test(url)) {
				return this.escapeHtml(url)
			}
			return '#'
		}
	}
}
</script>
